import "../../styles/App.css";
import { MouseEvent } from "react";
import SvgComponent from "../SVGShape";
import BaseText from "../BaseText";
import { IconStates } from "../../interfaces/types";
import { Link } from "react-router-dom";

interface SideNavProps {
  handleBtnClick: (event: MouseEvent<HTMLButtonElement>) => void;
  isActive: boolean;
  title: string;
  icon: IconStates;
  minimized?: boolean;
  buttonId: string;
  path?: string
}

const SideNavItem: React.FC<SideNavProps> = ({
  handleBtnClick,
  isActive,
  title = "Hey Man",
  icon,
  buttonId,
  path,
  minimized = false,
}) => {
 
  const content = (
    <>
      <button
        id={`button-${buttonId}`}
        onClick={(e) => handleBtnClick(e)}
        className={`flex items-center justify-start pl-8 sidebarItem ${isActive ? "active" : ""
          }`}
      >
        <div className="flex items-center relative gap-4">
          <>
            <SvgComponent icon={icon} iconActive={isActive} />
          </>
          <>
            <BaseText
              color={isActive ? "blue" : "black"}
              weight={isActive ? "semibold" : "medium"}
              size="small"
            >
              {title}
            </BaseText>
          </>
{/* { icon === 'puzzle' && <span className="absolute text-red-500 border-0 -bottom-2 font-semibold rounded-md left-28 text-xs ">Beta</span>} */}
        </div>
      </button>
    </>
  );

  return path ? <Link to={path}>{content}</Link> : content;
};

export default SideNavItem;
